import React from 'react';
import { Form, Button } from 'react-bootstrap';

function FilterController({
  table,
  allColumnsMap,
  columnsToFilter,
  setColumnsToFilter,
  openFilterModal,
}) {
  const { getAllLeafColumns } = table;

  const availableColumns = getAllLeafColumns().filter(
    (col) => col.getCanFilter() && col.id !== 'select'
  );

  const handleCheckboxChange = (columnId, isChecked) => {
    if (isChecked) {
      setColumnsToFilter([...columnsToFilter, columnId]);
    } else {
      setColumnsToFilter(columnsToFilter.filter((id) => id !== columnId));
    }
  };

  return (
    <div className="p-2" style={{ minWidth: '300px' }}>
      <h6 className="fw-bold">Seleziona Colonne da Filtrare</h6>
      <div style={{ maxHeight: '250px', overflowY: 'auto' }}>
        {availableColumns.map((col) => (
          <Form.Check
            key={col.id}
            type="checkbox"
            id={`filter-checkbox-${col.id}`}
            label={col.columnDef.header}
            checked={columnsToFilter.includes(col.id)}
            onChange={(e) => handleCheckboxChange(col.id, e.target.checked)}
          />
        ))}
      </div>
      <div className="d-grid gap-2 mt-3">
        <Button
          variant="primary"
          onClick={openFilterModal}
          disabled={columnsToFilter.length === 0}
        >
          Imposta Filtri Selezionati
        </Button>
      </div>
    </div>
  );
}

export default FilterController;
